<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
import Jt from 'common/util/jt';
import {inApp, isMQB} from 'common/constant';
export default {
    created() {
        if(!inApp) {
            Jt.dom.addClass(document.body, 'in-app');
        }
        if(isMQB) {
            Jt.dom.addClass(document.body, 'is-mqb');
        }
    },
    mounted() {
        this.resize();
        window.addEventListener('resize', this.resize, false);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resize);
    },
    methods: {
        resize() {
            if(window.innerWidth > window.innerHeight) {
                Jt.dom.addClass(document.body, 'landscape');
            } else {
                Jt.dom.removeClass(document.body, 'landscape');
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/App.vue